import {useEffect, useState} from "react";
import general from "../../general";
import moment from "moment";
import {NavLink} from "../../lib/Navigation";
import Dialog from "../../lib/Dialog";
import {Link, useHistory} from "react-router-dom";
import useActiveState from "../../lib/useActiveState";
import { useLockFn } from "ahooks";
import useUrlState from "@ahooksjs/use-url-state";
import IncomeAlert from "../components/alert/IncomeAlert";
import {Modal, Swiper} from 'antd-mobile';
import { useRef } from "react";
import SignAlert, { shouldShowSignAlert } from "./SignAlert";
import URI from "urijs";
import AuthAlert from "../components/AuthAlert";

export default props => {
  const [calendar, setCalendar] = useState([]);
  const history = useHistory();
  useEffect(() => {
    let days = [];
    let startDay = moment(moment().format('YYYY-MM-01')).day();
    if (startDay !== 0) {
      for (let i = 0; i < startDay; i++) {
        days.push(moment(moment().format('YYYY-MM-01')).add(-(i + 1), 'days'));
      }
      days.reverse();
    }
    let i = 0;
    while (true) {
      let day = moment(moment().format('YYYY-MM-01')).add(i, 'days');
      if (day.format('YYYY-MM-DD') === moment().add(1, 'months').format('YYYY-MM-01')) {
        break;
      }
      days.push(day);
      i++;
    }
    while (true) {
      if (days.length % 7 !== 0) {
        let tmp = days[days.length - 1];
        days.push(moment(tmp).add(1, 'days'));
      } else {
        break;
      }
    }
    setCalendar(days);
  }, []);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [data, setData] = useState({});
  const [signInfo, setSignInfo] = useState({});
  const [sign, setSign] = useState(false);
  const [dataSignInfo, setDataSignInfo] = useState({});
  const [user, setUser] = useActiveState('user');
  const [app] = useActiveState('app');
  const [dates, setDates] = useState();
  const [routerIndex, setRouterIndex] = useState(1);
  const [init, setInit] = useState(false);
  const [params, setParams] = useUrlState({}, {navigateMode: 'replace'});
  const swiperRef = useRef()
  const [isCheckAuth, setIsCheckAuth] = useState(false); //实名认证弹框状态
  const load =  useLockFn(async () => {
    Dialog.loading();
    await general.axios.post('/user/sign2601/getSignData')
        .finally(() => {
          Dialog.close();
        })
        .then(res => {
          // setLoaded(true);
          let {status, data} = res.data;
          // console.log(data);
          if (!status.succeed) {
            Dialog.error(status.error_desc);
          } else {
            let result = [];   //结果数组 
            let len = 7;

            for(var i=0;i<data.signData.length;i+=len){        
              result.push(data.signData.slice(i,i+len));    //循环取原数组N个元素,每次取从上次取的下一个开始取。
            }    
            setDates(result);
            setData(data);
            setInit(true);
            // setData({...data, ...data.user_info});
            // setSignInfo(data.sign_info);
            // setDataSignInfo(data.user_info);
          }
        })
        .catch(err => {
          Dialog.error(err.message);
        });
  });

  // console.log(dates);

  useEffect(() => {
    load();
  }, []);

  const urlLogin = () => {
    if (params.userid && params.username && params.token) {
      localStorage.setItem('user_id', params.userid);
      localStorage.setItem('username', params.username);
      localStorage.setItem('token', params.token);

      load_load();
    }
  }
  const load_load = useLockFn(async () => {
    await general.axios.post('/user/user/getMemberInfo')
      .finally(() => {
      })
      .then(response => {
        let {status, data} = response.data;
        if (!status.succeed) {

        } else {
          setUser({isLogin: true, ...data.member_info});
        }
      })
      .catch(err => {
          Dialog.error(err.message);
        });
  })
  useEffect(()=>{
    urlLogin()
  },[]);

  const [swiper, setSwiper] = useState(null);
  useEffect(() => {
    if (swiper) {
      swiper.update();
    }
  }, [swiper]);

  useEffect(() => {
    if (swiper) {
      swiper.slideTo(routerIndex, 0, false);
    }
  }, [routerIndex, swiper]);

  const handleTodaySigned = ()=>{
    if (!data.todaySigned) {
      Dialog.loading();
      general.axios.post('/user/sign2601/sign')
        .finally(() => {
          Dialog.close();
        })
        .then(response => {
          let result = response.data;
          if (!result.status.succeed) {
            Dialog.error(result.status.error_desc);
          } else {
            setGoid(result.data.amount)
            setTips1(result.data.tips1)
            setTips2(result.data.tips2)
            setVisible(true)
            load();
          }
        })
        .catch(error => {
          Dialog.error(error.message);
        });
    } else {
      Dialog.info("今日已经签过到了");
    }
  }

  const signOperate = useLockFn(() => {
    if (app.is_overseas){
      if (!user.email && !user.mobile){
        Dialog.confirm({
          title: '没有绑定邮箱，现在去绑定？',
          yes: () => {
            history.push('/user/email');
          }
        });
      }else{
        handleTodaySigned()
      }
    }else{
      if (!user.mobile) {
        Dialog.confirm({
          title: '没有绑定手机号，现在去绑定？',
          yes: () => {
            history.push('/user/phone');
          }
        });
      } else {
        handleTodaySigned()
      }
    }
  })

  const criticalHit = () => {
    // history.push('/save/newvip?levelid=3');
    if (app.is_overseas){
      if (!user.email && !user.mobile){
        Dialog.confirm({
          title: '没有绑定邮箱，现在去绑定？',
          yes: () => {
            history.push('/user/email');
          }
        });
      }else{
        history.push('/save/newvip?levelid=3');
      }
    }else{
      if (!user.mobile) {
        Dialog.confirm({
          title: '没有绑定手机号，现在去绑定？',
          yes: () => {
            history.push('/user/phone');
          }
        });
      } else {
        history.push('/save/newvip?levelid=3');
      }
    }
    
  }
  // console.log(data.vip_add_balance);

  useEffect(()=>{
    props.setOperate(
      <NavLink 
        user={false} 
        to={URI('https://sys.99maiyou.com/home/boxVarietyRules/checkRules').toString()}
        iframe={{title: '签到规则'}}
      >
        <div className="rule">签到规则</div>
      </NavLink>
    )
  },[props.active])

  useEffect(()=>{
    load()
  },[localStorage.getItem('username')])

  const [visible,setVisible] = useState(false)
  const [goid,setGoid] = useState('')
  const [tips1,setTips1] = useState('')
  const [tips2,setTips2] = useState('')

  return <div className="signdata-index" style={{display:init ? '' : 'none'}}>
    {visible && <IncomeAlert numbers={parseInt(user.vip_level) > 0 ? true : false} close={()=>setVisible(false)} render={()=>{
      return <div style={{textAlign:'center'}}>恭喜您获得<span>{goid}</span>个金币
        {tips1.length > 0 && <div style={{fontSize:12,paddingTop:10,color:'#68251A',fontWeight:'normal'}}>{tips1}</div>}
        {tips2.length > 0 && <div style={{fontSize:12,color:'#68251A',fontWeight:'normal'}}>{tips2}</div>}
      </div>
    }}></IncomeAlert>}
    <AuthAlert isCheckAuth={isCheckAuth} onClose={() => setIsCheckAuth(false)} handleAuthSuccess={info=>{
          setUser({...user,...info})
        }}></AuthAlert>
    <div className="task-money">
      <div className="money">
        <div className="label">当前金币（个）</div>
        <div className="value">
          <img src="resources/251222/gold.png" alt="" height={34} width={34} style={{marginRight:3}}/>
          <div>{data.balance}</div>
        </div>
      </div>
      <img src="resources/251222/sign-top.png" alt="" height={168} width={168}/>
      <div style={{position:'absolute',right:15,top:'calc(env(safe-area-inset-top) + 40px + 35px)'}}>
        <NavLink user={true} to="/user/bill?type=2">
        <div style={{display:'flex',alignItems:'center',backgroundColor:'#ffffffbb',padding:'3.5px 10px',borderRadius:13.5}}>
          <div style={{color:'#4B2609',fontSize:13,paddingRight:3}}>金币记录</div>
          <img src="resources/251222/sign_right.png" alt="" height={8}/>
        </div>
      </NavLink>
      </div>
    </div>
    <div className="task-sign">
      <div style={{
        background:'linear-gradient(#FFF6EF, #FFF6EF00)',padding:'2px',height:85,position: 'absolute',borderRadius:13,
        left: '2px',top: '2px',right: '2px'}}></div>
      <div className="title"><img src="/resources/251222/every_sign.png" alt=""/></div>
      <div style={{position:'absolute',left:15,top:40,fontSize:12,color:'#666'}}>开通会员金币奖励翻倍，享受多项专属特权</div>
      <div className="progress-new">

        {/* <div className="hx"><span style={{width: '' + (data.month_keep_day / 28 * 100) + '%'}}/></div> */}
        <ul>

        </ul>
        
        <div className="dates-list">
          <Swiper
            indicator={() => null}
            defaultIndex={routerIndex}
            onIndexChange={index => setRouterIndex(index)}
            ref={swiperRef}
          >
            {
              dates ? 
                dates?.map(item => <Swiper.Item>
                  <div className="items">
                    {
                      item.map((d,index) => <div className={'date-number '}>
                        {d.tips.length > 0 && <div key={index} className="d-tips">{d.tips}</div>}
                        <div className={"item " + (d.signed ? 'active' : '')}>
                        <img src={'resources/251222/' + (d.signed ? 'signed.png' : 'unsigned.png')} alt="" height={24}/>
                          <div className="value">{d.text}</div>
                        </div>
                        <div className="label">{d.signDate}</div>
                      </div>)
                    }
                  </div>
                </Swiper.Item>)
              : null
            }
            
          </Swiper>

          <div className="swiper-button-prev" style={{backgroundImage:"url(/resources/251222/left.png)",display:(routerIndex==0?'none':'block')}} onClick={()=>{
            swiperRef.current?.swipePrev()
          }}></div>
          <div className="swiper-button-next" style={{backgroundImage:"url(/resources/251222/right.png)",display:(routerIndex==2?'none':'block')}} onClick={()=>{
            swiperRef.current?.swipeNext()
          }}></div>

        </div>

      </div>
      {/* <NavLink user={true} className={'btn ' + (data?.todaySigned ? 'disable' : '')} onClick={() => signOperate()}>
        {data?.todaySigned ? '今日已签' : '签到+' + (data.todaySignGetBalance ?? '?')}
        {data?.todaySigned ? 
        <div className="tips" style={{backgroundImage:"url(/resources/task/sign-already-tips.png)"}}>
          {data.nextReward}
        </div>
        :null}
      </NavLink> */}

      {data && init ? 
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',paddingBottom:9, paddingTop:'1em'}}>
        <div>
          <div style={{color:'#4B2609',fontSize:15}}>
            已连续签到<span style={{fontSize:22,color:'#FF5E00',fontWeight:500}}>{data.streakDays}</span>天
          </div>
          <div style={{color:'#999',fontSize:12,lineHeight:1}}>{data.remainingDaysToRewardTips}</div>
        </div>
        <NavLink style={{position:'relative'}}>
          <img src={'resources/251222/' + (data.todaySigned ? 'signed_bg.png' : 'sign_bg.png')} alt="" height={48}/>
          <div onClick={()=>{
            if (general.isLogin() == false) {
              return
            }
            if(user.isCheckAuth && !user.isRealNameAuth) {
              setIsCheckAuth(true);
              return;
            }
            if (data.todaySigned) {
              return
            }
            if (!data?.isVip) {
              if (shouldShowSignAlert()) {
                Modal.show({
                  content: <SignAlert data={data} handleSign={signOperate} handlePushVip={()=>{
                    general.history.push('/save/newvip?from_sign=1')
                  }}></SignAlert>,
                  bodyClassName:'sign-alert-modal',
                  getContainer:document.getElementById('root'),
                  bodyStyle:{
                    padding:0
                  }
                })
              }else{
                signOperate()
              }
            }else{
              signOperate()
            }
          }} style={{position:'absolute',left:0,right:0,top:0,bottom:0,color:'white',fontSize:16,fontWeight:'bold',display:'flex',alignItems:'center',justifyContent:'center'}}>{data.todaySigned ? '今日已签' : '立即签到'}</div>
        </NavLink>
        {/* <NavLink user={true} style={{backgroundImage:"url(/resources/task/"+(data?.todaySigned ? 'normal-already.png' : 'normal.png')+")"}} className={'btn normal' + (data?.todaySigned ? 'disable' : '')} onClick={() => signOperate()}>
          {data?.todaySigned ? '今日已签' : 
          <div className="btn-des"> <div className="text">普通签到</div> <div className="balence-nums">+{(data.todaySignGetBalance ?? '?')}金币</div> </div>
          }
        </NavLink>

        {!data?.isVip ? <>
        <NavLink user={true} to="/save/newvip" style={{backgroundImage:"url(/resources/task/"+(data?.isVip && data?.todaySigned ? 'critical-already.png' : 'critical.png')+")"}} className={'btn critical' + (data?.todaySigned ? 'disable' : '')} >
          {data?.isVip && data?.todaySigned ? '今日已签' : 
          <div className="btn-des"> <div className="text">暴击签到</div> <div className="balence-nums">最高+6金币</div> </div>
          }
        </NavLink>
        
        <div className="sign-bg-bottom"><img src="/resources/task/sign-bg-bottom.png" /></div></>
        : null} */}

        {/* {
          data?.isVip ? <>
          <NavLink user={true} style={{backgroundImage:"url(/resources/task/"+(data?.todaySigned ? 'critical-already.png' : 'critical.png')+")"}} className={'btn critical' + (data?.todaySigned ? 'disable' : '')} onClick={() => signOperate()}>
            {data?.isVip && data?.todaySigned ? '今日已签' : 
            <div className="btn-des"> <div className="text">暴击签到</div> <div className="balence-nums">+{(data.todaySignGetBalance ?? '?')}金币</div> </div>
            }
          </NavLink>
          </>
          : <>
          <NavLink user={true} style={{backgroundImage:"url(/resources/task/"+(data?.todaySigned ? 'normal-already.png' : 'normal.png')+")"}} className={'btn normal' + (data?.todaySigned ? 'disable' : '')} onClick={() => signOperate()}>
            {data?.todaySigned ? '今日已签' : 
            <div className="btn-des"> <div className="text">普通签到</div> <div className="balence-nums">+{(data.todaySignGetBalance ?? '?')}金币</div> </div>
            }
          </NavLink>
          <NavLink user={true} onClick={() => criticalHit()} style={{backgroundImage:"url(/resources/task/critical.png)"}} className={'btn critical'} >
            <div className="btn-des">
              <div className="text">{data?.todaySigned ? '去开卡' : '暴击签到'}</div> 
              <div className="balence-nums">{data?.todaySigned ? '明日暴击签' : '最高+6金币'}</div> 
            </div>
          </NavLink>
          
          <div className="sign-bg-bottom"><img src="/resources/task/sign-bg-bottom.png" /></div>
          </>
        } */}

      </div>
      : null}


    </div>
    

    <div style={{backgroundColor:'white',marginTop:10,borderRadius:13,padding:2}}>
      <div>
        <div style={{padding:'15px 13px 0',height:80,background:'linear-gradient(#FFF6EF, #FFF6EF00)',borderRadius:13}}>
          <img src="resources/251222/sign_lx.png" alt="" height={22}/>
          <div style={{color:'#666',fontSize:12,paddingTop:5}}>连续签到领额外奖励，自动发放可循环领取</div>
        </div>
        <div style={{display:'flex',flexWrap:'wrap',padding:'0 10px',justifyContent:'space-between',position:'relative',top:-5}}>
          {data?.signRewards?.map((item,index)=>{
            return <div key={index} style={{marginBottom:8,width:'49%',backgroundColor:'#FFF6EF',display:'flex',alignItems:'center',padding:'10px 13px',borderRadius:8}}>
              <div style={{flex:1}}>
                <div style={{color:'#4B2609',fontSize:14}}>{item.title}</div>
                <div style={{color:'#FF5E00',fontSize:12,paddingTop:2}}>{item.reward}</div>
              </div>
              <img src={item.icon} alt="" height={25}/>
            </div>
          })}
        </div>
      </div>
    </div>

    <div className="sign-woolgathering">
      <div style={{background:'linear-gradient(#FFF6EF, #FFF6EF00)',height:80,position:'absolute',top:2,left:0,right:2,borderRadius:13}}></div>
      <div className="title"><img src="/resources/251222/sign_hym.png" height={22}/></div>

      <div className="items">
        {data?.recommendItems?.map((item, i) => {
          return <div key={i} className="item">
            <div className="icon">
              <img src={item.icon} />
            </div>
            <div className="entry">
              <div className="info">
                <div className="name">{item.title}</div>
                <div className="desc">{item.desc}</div>
              </div>
              <NavLink className="operate" user={false} to={(() => {
                if(item.type == 'mcard') {
                  return '/save/newcard';
                } else if(item.type == 'vip') {
                  return '/save/newvip?from_sign=1';
                } else if(item.type == 'tryPlay') {
                  return '/task/tryplay?topic_id=' + (params.topic_id || '');
                }
              })()}>
                <div style={{position:'relative'}}>
                  <img src={item.buttonBgImg} height={36}/>
                  <div style={{position:'absolute',left:0,right:0,top:0,bottom:0,fontSize:12,color:'white',fontWeight:500,display:'flex',alignItems:'center',justifyContent:'center'}}>{item.button}</div>
                </div>
              </NavLink>
            </div>
          </div>
        })}

      </div>

    </div>

    {/* <div to={"/save?type=vip"} className="sign-coin-award">
      <NavLink to={"/save?type=vip"}>
        <img src="/resources/task/fb.png" />
      </NavLink>
    </div> */}

    {/* <div className="sign-title">
      <img src="/resources/task/sign-title-milu.png" alt=""/>
      本月已经连续签到{data.month_keep_day}天
      本月最长连续签到{data.month_max_keep_day}天
    </div> */}
    {/* <div className="sign-calendar">
      <div className="title">{moment().format('YYYY年MM月')}</div>
      <div className="main clearfix">
        <div className="item disable">日</div>
        <div className="item disable">一</div>
        <div className="item disable">二</div>
        <div className="item disable">三</div>
        <div className="item disable">四</div>
        <div className="item disable">五</div>
        <div className="item disable">六</div>
        {calendar.map(item => <div className={'item'
        + (item.format('YYYY-MM') !== moment().format('YYYY-MM') ? ' disable' : ' sign')
        + (data.sign_date_list?.find(item2 => item2 === item.format('YYYY-MM-DD')) ? ' active' : '')
        } style={{
          backgroundImage: 'url(' + (
            data.sign_date_list?.find(item2 => item2 === item.format('YYYY-MM-DD')) ? '/resources/task/sign2.png' : (item.format('YYYY-MM') === moment().format('YYYY-MM') ? '/resources/task/sign1.png' : '')
          ) + ')'
        }}>
          {item.format('DD')}
        </div>)}
      </div>
    </div> */}
    {/* <div className="sign-operate">
      <NavLink to="/save?type=vip" className="vip">开通会员 享金币加成</NavLink>
      <div className="role" onClick={() => Dialog.alert('签到规则', <><div className="sign-record-desc">
        <p>1.普通用户每签到1次可获得1金币奖励，会员每签到一次可额外获得相应身份金币奖励（子爵额外得1金币，伯爵2金币，公爵3金币，国王5金币，皇帝20金币）；</p>
        <p>2.连续签到<span>3天／7天／15天／28天</span>，分别可领取 额外奖励<span>10金币／20金币／50金币／100金币</span>。 连续签到时间越长，金币越丰厚；</p>
        <p>3.普通用户连续签到满28天，可获得208个积 分；</p>
        <p>4.签到中断或每月第1天，连续签到天数将重新 进行计算；</p>
        <p>5.同一手机／设备／身份证视为同一用户；</p>
        <p>6.本活动最终解释权归咪噜游戏官方所属 </p>
        </div>
      </>)}>
        查看签到规则
      </div>
    </div> */}
    {/* {loaded && !signInfo.today_issign && sign ? <div className="sign-alert"> */}
    {sign ? <div className="sign-alert">
      <div className="mask" onClick={() => setSign(false)}/>
      <div className="entity" style={{backgroundImage: 'url(/resources/task/sign-alert.png)'}}>
        <div className="info">恭喜您本次签到<br/>获得{data.today_sign_get_balance}金币</div>
        <div className="desc">您已经连续签到{data.month_keep_day}天</div>
        <div className="btn" onClick={() => setSign(false)}>好的</div>
      </div>
    </div> : null}
  </div>;
};